import React, { useState, useCallback, useEffect } from 'react'
import '../../_css/Addons.css'
import { createAddonCheckout, getAddons } from '../../requests'
import { notifyError, notifySuccess } from '../../utils/helper'
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer'
import { useDispatch } from 'react-redux'

const Index = () => {
  const [data, setData] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentReady, setPaymentReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAddons();
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_PEACH_CHECKOUT_URL;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePay = async (plan_id) => {
    setLoading(true);
    dispatch(startLoader());
    setPaymentReady(false);

    try {
      const resp = await createAddonCheckout({
        addon_id: plan_id,
      });

      const data = await resp.data;

      if (window.Checkout && data.checkoutId) {
        // Payment link is ready, open modal
        setPaymentReady(true);
        setShowPaymentModal(true);

        // Small delay to ensure modal is rendered before rendering checkout
        setTimeout(() => {
          // const checkout = window.Checkout.initiate({
          //   key:
          //     process.env.REACT_APP_PEACH_ENTITY_ID ||
          //     "8ac7a4c89b2a46a7019b2bad6fdf025c",
          //   checkoutId: data.checkoutId,
          // });

          // checkout.render("#payment-form");
          const checkout = window.Checkout.initiate({
            key:
              process.env.REACT_APP_PEACH_ENTITY_ID,
            checkoutId: data.checkoutId,
            events: {
              onCompleted: (event) => {
                // console.log("Payment completed event:", event);
                notifySuccess("Payment successful!");
                handleCloseModal();
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
                // window.location.reload();
                // e.g., update subscription UI or call backend to update DB
              },
              onCancelled: (event) => {
                console.log("Payment cancelled:", event);
                notifyError("Payment cancelled");
                handleCloseModal();
              },
              onExpired: (event) => {
                console.log("Payment expired:", event);
                notifyError("Session expired");
                handleCloseModal();
              },
              onError: (event) => {
                console.error("Payment error:", event);
                notifyError("An error occurred during payment");
                handleCloseModal();
              },
            },

            onClose: () => {
              console.log("Peach checkout closed by user");
              handleCloseModal();
            },
          });

          checkout.render("#payment-form");
        }, 100);
      } else {
        console.error("Peach Checkout script not loaded or checkoutId missing");
      }
    } catch (error) {
      console.error("Error creating checkout:", error);
    } finally {
      setLoading(false);
      dispatch(stopLoader());
    }
  };

  const fetchAddons = useCallback(async () => {
    try {
      const response = await getAddons();
      if (response.status == 200) {
        setData(response.data.data);
      }

    } catch (error) {
      console.log(error);
      notifyError(error?.response?.data?.error || "Something went wrong");


    }
  }, []);

  const handleCloseModal = () => {
    setShowPaymentModal(false);
    setPaymentReady(false);
    // Clear the payment form content
    const paymentForm = document.getElementById("payment-form");
    if (paymentForm) {
      paymentForm.innerHTML = "";
    }
  };

  return (
    <div className="addons-container">
      <div className="addons-grid">
        {data.length === 0 ? (
          <div className="no-addons-found" >
            <h2>No addons found</h2>
          </div>
        ) : (
          data.map((item) => (
            <div key={item.id} className="addon-card">
              <div className="addon-card-header">
                <h2 className="addon-card-title">{item?.name}</h2>
                <span className="addon-card-price">R {item?.price}</span>
              </div>
              <div className="addon-card-details">
                <div className="addon-card-row">
                  <strong>Validity</strong>
                  <span>{item?.validity || 'Same as base plan'}</span>
                </div>
                <div className="addon-card-row">
                  <strong>Pages</strong>
                  <span>{item?.credits}</span>
                </div>
                <div className="addon-card-row">
                  <strong>Payment</strong>
                  <span>{item?.paymentType || 'Once off'}</span>
                </div>
              </div>
              <div className="addon-card-footer">
                <button
                  type="button"
                  className="addon-card-cta"
                  onClick={() => handlePay(item?.id)}
                >
                  Select {item?.name}
                </button>
              </div>
            </div>
          ))
        )}
        {/* Payment Modal */}
        {showPaymentModal && paymentReady && (
          <div className="payment-modal-overlay" onClick={handleCloseModal}>
            <div
              className="payment-modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="payment-modal-head">
                <div className="payment-modal-head-text">Complete Payment</div>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={handleCloseModal}
                  src="/close.svg"
                  alt="Close"
                />
              </div>
              <div className="payment-modal-body">
                <div
                  className="d-flex justify-content-center peach-payment-form"
                  id="payment-form"
                ></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Index